import React from "react";
import Image from "next/image";
import formatFileSize from "lib/formatFileSize";
import { DownloadIcon, EyeIcon } from "@heroicons/react/outline";
import useTranslation from "next-translate/useTranslation";

export default function NodePublicationTeaser({ node }) {
  const extension = node.field_file.filename.split(".").pop();
  const filesize = formatFileSize(node.field_file.filesize);
  const { t } = useTranslation("common");

  return (
    <article className="pt-16">
      <div className="flex flex-col bg-white shadow-spread">
        <div className="order-2 py-12 px-8 text-center">
          <h3 className="text-xl font-important font-bold mb-4">
            {node.title}
          </h3>

          <div className="flex items-center justify-center gap-2 uppercase text-sm font-important font-medium tracking-wider mb-4">
            <span className="text-secondary">{extension}</span>
            <span className="text-gray-400"> / </span>
            <span className="text-secondary">{filesize}</span>
          </div>

          <div className="flex items-center justify-center flex-col xl:flex-row gap-4">
            <a
              href={`${process.env.NEXT_PUBLIC_DRUPAL_RUNTIME_BASE_URL}${node.field_file.uri.url}`}
              className="group inline-flex items-center py-4 px-8 rounded-full border text-sm font-semibold no-underline transition-colors border-secondary-light bg-secondary-light hover:border-secondary hover:bg-secondary hover:text-white"
              title={`Ouvrir "${node.field_file.filename}" dans un nouvel onglet`}
              target="_blank"
              rel="noreferrer"
            >
              <EyeIcon className="h-4 w-4 mr-2 text-secondary group-hover:text-white transition-colors" />
              <span>{t("utils.files.see")}</span>
            </a>

            <a
              href={`${process.env.NEXT_PUBLIC_DRUPAL_RUNTIME_BASE_URL}${node.field_file.uri.url}`}
              className="group inline-flex items-center py-4 px-8 rounded-full border text-sm font-semibold no-underline transition-colors border-secondary-light bg-secondary-light hover:border-primar hover:bg-secondary hover:text-white"
              title={`Télécharger "${node.field_file.filename}" (${filesize})`}
              download
            >
              <DownloadIcon className="h-4 w-4 mr-2 text-secondary group-hover:text-white transition-colors" />
              <span>{t("utils.files.download")}</span>
            </a>
          </div>
        </div>
        <div className="order-1 flex-initial text-center">
          <a
            href={`${process.env.NEXT_PUBLIC_DRUPAL_RUNTIME_BASE_URL}${node.field_file.uri.url}`}
            className="group inline-block w-1/2 -mt-16 shadow-spread"
            title={`Ouvrir "${node.field_file.filename}" dans un nouvel onglet`}
            target="_blank"
            rel="noreferrer"
          >
            <div className="aspect-w-21 aspect-h-29.7">
              <Image
                src={`${process.env.NEXT_PUBLIC_DRUPAL_BASE_URL}${node.field_image.uri.url}`}
                width={210}
                height={297}
                layout="fill"
                objectFit="cover"
                alt={node.field_image?.alt}
                quality={100}
              />
            </div>
          </a>
        </div>
      </div>
    </article>
  );
}
